import { render } from "./403.vue?vue&type=template&id=4d5f351a&scoped=true"
const script = {}

import "./403.vue?vue&type=style&index=0&id=4d5f351a&scoped=true&lang=less"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5f351a"]])

export default __exports__